export type TColor = 'green' | 'red' | 'orange';

export const colors: TColor[] = ['green', 'orange', 'red'];
